import { PricingRequest } from "system/Domain";
import LayoutNavigation from "../Components/Layout/LayoutNavigation";
import PricingRequestNavigationSection from "./PricingRequestNavigationSection";
import RootNavigationSection from "./RootNavigationSection";
import SalesNavigationSection from "./SalesNavigationSection";

interface Props {
	request?: PricingRequest
	vehicleId?: string
	assessmentId?: string
}

export default ({ request, vehicleId, assessmentId }: Props) => {
	return (
		<LayoutNavigation>
			{request && (
				<PricingRequestNavigationSection request={request} vehicleId={vehicleId} assessmentId={assessmentId} />
			)}
			<SalesNavigationSection />
			<RootNavigationSection />
		</LayoutNavigation>
	);
};
